import { Navigate, useNavigate } from "react-router-dom";
import { KeyRound, LogOut } from "lucide-react";
import PasswordForm from "@/components/PasswordForm";
import { Loading } from "@/components/common";
import { useAuth } from "@/context/AuthContext";

export default function ChangePassword() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  if (user === null) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  if (!user.must_change_password) return <Navigate to="/" replace />;
  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-[#F4F6F9]">
      <div className="w-full max-w-md rise" data-testid="force-password-page">
        <div className="mb-8 rounded-xl bg-[#0E2D43] flex justify-center py-4">
          <img src="/logo-presthyg.png" alt="Prest'hyg" className="w-36 h-auto mix-blend-lighten" />
        </div>
        <div className="flex items-center gap-2 text-[#F49619] text-[11px] uppercase font-bold tracking-[0.2em]"><KeyRound className="w-4 h-4" /> Première connexion</div>
        <h1 className="font-display text-3xl font-bold text-[#0E2D43] mt-2">Choisissez votre mot de passe</h1>
        <p className="text-sm text-slate-500 mt-2 mb-6">Bonjour {user.name}, pour activer votre compte, remplacez le mot de passe provisoire communiqué par l'administrateur par un mot de passe personnel.</p>
        <div className="bg-white border border-slate-200 rounded-xl p-5">
          <PasswordForm currentLabel="Mot de passe provisoire" submitLabel="Activer mon compte" onDone={() => nav("/")} />
        </div>
        <button onClick={() => { logout(); nav("/login"); }} className="mt-4 text-sm text-slate-500 hover:text-[#0E2D43] inline-flex items-center gap-1.5" data-testid="force-password-logout">
          <LogOut className="w-4 h-4" /> Se déconnecter
        </button>
      </div>
    </div>
  );
}
